module.exports = __webpack_public_path__ + "footbanner2_2.png?3f95f3162800c0946becd0e71be6e8f2";